<template>
  <div class="activity-overview" v-if="info">
    <div class="info-card">
      <div class="info-card-top">
        <div class="flex-grow flex-box align-center">
          <div class="info-card-title">基本信息</div>
          <div class="info-card-status" :class="[`activity-status-${info.status}`]">{{info.statusText}}</div>
        </div>
        <router-link
          :to="{name: 'ActivityDetail', params: {id: info.id}}"
          class="flex-box align-center info-card-more"
          slot="extra">
          <span>查看详情</span>
          <a-icon type="right" />
        </router-link>
      </div>
      <div class="flex-box align-center info-card-content">
        <detail-list :list="info.detailList"></detail-list>
        <div class="info-qr-box">
          <div class="info-qr-title">签到码</div>
          <vue-qr
            class="mobile-qr-img"
            :text="`https://mobile.globalmice.com.cn/reception/${info.id}/sign`"
            :margin="0"
            color-dark="#036DB8"
            color-light="transparent"
            :size="64"
          ></vue-qr>
        </div>
        <div class="info-qr-box">
          <div class="info-qr-title">邀请函</div>
          <vue-qr
            class="mobile-qr-img"
            :text="`https://mobile.globalmice.com.cn/reception/${info.id}/invite`"
            :margin="0"
            color-dark="#036DB8"
            color-light="transparent"
            :size="64"
          ></vue-qr>
        </div>
        <a-popover v-model="visible" placement="leftTop">
          <div class="info-card-qr" slot="content">
            <img :src="qr" class="card-qr-img" v-if="qr">
            <div class="card-qr-loading" v-else>
              <a-spin>
                <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
              </a-spin>
            </div>
          </div>
          <div class="info-qr-box">
            <div class="info-qr-title">首页</div>
            <vue-qr
              class="mobile-qr-img"
              :text="`https://mobile.globalmice.com.cn/reception/${info.id}`"
              :margin="0"
              color-dark="#036DB8"
              color-light="transparent"
              :size="64"
            ></vue-qr>
          </div>
        </a-popover>
      </div>
    </div>
    <div class="info-card">
      <div class="info-card-top">
        <div class="flex-grow info-card-title">活动进度</div>
        <router-link
          :to="{name: 'ActivityGroup', params: {id: info.id}}"
          class="flex-box align-center info-card-more"
          slot="extra">
          <span>查看详情</span>
          <a-icon type="right" />
        </router-link>
      </div>
      <div class="activity-progress-area">
        <div class="activity-progress">
          <a-progress style="line-height: 1" stroke-color="#036DB8" :percent="info.per" :stroke-width="13" />
        </div>
        <div class="card-sub-title">日程进度</div>
        <div class="activity-group-list" v-if="info.schList && info.schList.length > 0">
          <div class="activity-group-item" v-for="s in showMore ? info.schList : info.schList.slice(0, maxShowNum)" :key="s.date">
            <div class="activity-group-progress">
              <div class="flex-box align-center">
                <div class="flex-grow activity-group-name">{{s.date}}</div>
              </div>
              <a-progress :percent="s.per" :stroke-width="6" stroke-color="#036DB8" />
            </div>
          </div>
        </div>
        <a-empty :image="simpleImage" description="暂无日程" v-else/>
        <div class="activity-group-more" @click="showMore = !showMore" v-if="info.schList.length > maxShowNum">{{ showMore ? '收起更多' : '查看更多' }}</div>
      </div>
    </div>
    <div class="info-card">
      <div class="info-card-top">
        <div class="flex-grow info-card-title">活动统计</div>
      </div>
      <div class="info-card-content">
        <div class="info-card-data">
          <div class="card-data-item" v-for="(m, i) in member" :key="i">{{m.title}}<span class="card-data-num">{{m.num}}</span></div>
        </div>
      </div>
      <a-row :gutter="26" style="padding: 20px">
        <a-col :span="6" v-for="(t, i) in typeList" :key="i">
          <a-card
            class="info-chart-item"
            size="small"
            :body-style="{padding: '16px 12px'}"
            :head-style="{padding: '5px 12px',textAlign: 'center'}"
            :title="t.title"
            :bordered="false">
            <div class="flex-box align-center">
              <div class="info-chart-num" v-for="(a, j) in t.itemList" :key="j">{{a.title}} {{a.num}}</div>
            </div>
            <div class="type-chart-box">
              <div class="type-chart-legend">
                <div class="chart-legend-item" v-for="(l, j) in t.data" :key="j">
                  <div class="chart-legend-title">{{l.name}}</div>
                  <div class="chart-legend-value">
                    <span>{{l.value}}</span>
                    <span>{{l.per}}%</span>
                  </div>
                </div>
              </div>
              <div class="type-chart-area" :id="`chart_${i}`"></div>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import {Empty} from "ant-design-vue";
import * as echarts from 'echarts';
import VueQr from 'vue-qr'
import {
    dealActivity, getActivityDayList,
    getProgressPercent
} from "../../common/activity/activity";
import config from "../../common/js/config";
import DetailList from "../../layouts/DetailList";
import {clone} from "../../common/js/tool";
import chartOption from "../../common/activity/chart";

const chartData = [{value: 0, name: '已分配'}, {value: 0, name: '未分配'}];
const allocation = {title: '规格', num: 0};
const vehicle = [
    {title: '司机', num: 0},
    {title: '车辆', num: 0},
    {title: '通行证', num: 0}
]

export default {
  name: "ActivityInfo",
  components: {
    DetailList,
    VueQr
  },
  data() {
    return {
      qr: null,
      form: {},
      visible: false,
      info: null,
      bodyStyle: {padding: '8px 0'},
      statusColor: ['#FF8C00', '#07C160', '#FF4800'],
      member: [
        {title: '邀请嘉宾', icon: 'icon-guest', num: 0},
        {title: '随行人员', icon: 'icon-companion', num: 0},
        {title: '外部人员数量', icon: 'icon-staff', num: 0},
        {title: '接待人员数量', icon: 'icon-reception', num: 0},
      ],
      typeList: [
        { title: '用餐', data: clone(chartData), itemList: [{...allocation}] },
        { title: '住宿', data: clone(chartData), itemList: [{...allocation}] },
        { title: '车辆', data: clone(chartData), itemList: clone(vehicle) },
        { title: '礼品', data: clone(chartData), itemList: [{...allocation}] },
      ],
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      showMore: false,
      maxShowNum: 6
    };
  },
  computed: {
    activity() {
      return this.$store.getters.activity;
    },
  },
  watch: {
    activity(){
      this.getActivityData();
    },
  },
  created() {
    this.getActivityData();
  },
  methods: {
    getActivityData() {
      const activity = this.activity;
      if(activity) {
        // 不是统筹人或者统筹小组成员 跳转活动详情页
        if(activity.charge_status == 0) {
          this.$router.replace({name: 'ActivityDetail', params: {id: activity.id}});
          return;
        }
        const url = `/activity/activity/get-data?id=${activity.id}`;
        this.$axios(url).then(info => {
          info.per = getProgressPercent(info.progress);
          if (info.group) {
            info.schList = getActivityDayList(info, info.group);
          }
          dealActivity(info);
          const member = [...this.member];
          member[0].num = info.guest_count[0] || 0;
          member[1].num = info.guest_count[1] || 0;
          member[2].num = info.r_count[0] || 0;
          member[3].num = info.r_count[1] || 0;
          const total = member[0].num + member[1].num;
          chartOption.series[0].max = total;
          const typeList = this.getTypeListData(info, total);
          this.member = member;
          this.typeList = typeList;
          this.info = info;
          this.$nextTick(() => {
            this.setTypeChart();
          })
        });
        this.getActivityQr();
      }
    },
    setTypeChart() {
      this.typeList.forEach((t, i) => {
        const id = `#chart_${i}`;
        t.chart = echarts.init(this.$el.querySelector(id));
        const option = clone(chartOption);
        option.series[0].data = [t.data[0].value];
        t.chart.setOption(option);
      })
    },
    getTypeListData(info, total) {
      const typeList = [...this.typeList];
      const dataList = [info.dinner_count, info.hotel_count, info.v_count, info.gift_count];
      typeList.forEach((item, i) => this.setTypeData(item, total, dataList[i]));
      return typeList;
    },
    setTypeData(type, total, data) {
      data = data || {};
      let ts, tw;
      if(type.title == '车辆') {
        ts = data[2] || 0, // 已分配
        type.itemList[1].num = data[1] || 0;
        type.itemList[2].num = data[3] || 0;
      } else {
        ts = data[1] || 0; // 已分配
      }
      type.itemList[0].num = data[0] || 0;
      tw = (total - ts) < 0 ? 0 : (total - ts); // 未分配
      type.data[0].value = ts;
      type.data[0].per = total > 0 ? (ts / total * 100).toFixed(2) * 1 : 0;
      type.data[1].value = tw;
      type.data[1].per = total > 0 ? (tw / total * 100).toFixed(2) * 1 : 0;
    },
    getActivityQr() {
      if(this.activity && !this.qr) {
        const url = `/activity/live/share-code`;
        this.$axios({
          url,
          method: "POST",
          data: {
            path: `pages/home/home?activity_id=${this.activity.id}`
          }
        }).then(res => {
          this.qr = config.host + "/" + res.data;
        })
      }
    },
  },
};
</script>

<style lang="less">
.activity-overview {
  margin: 0 auto;
  padding: 10px 0 32px;
  width: 1200px;
  align-self: flex-start;
}
.info-card {
  margin-top: 20px;
  padding: 4px 0;
  background-color: @component-background;
  border-radius: 8px;
}
.info-card-top {
  display: flex;
  align-items: center;
  position: relative;
  padding: 8px 20px;
  border-bottom: 1px solid #E8E8E8;
}
.info-card-title {
  font-size: 20px;
  font-weight: 500;
}
.info-card-status {
  margin-left: 20px;
  padding: 2px 4px;
  border-radius: 4px;
  border: 1px solid #D08813;
  line-height: 16px;
  font-size: 12px;
  color: #D08813;
  &.activity-status-2 {
    color: #07C160;
    border-color: #07C160;
  }
  &.activity-status-3 {
    color: #FF4800;
    border-color: #FF4800;
  }
}
.info-card-more {
  color: #999999;
}
.info-card-content {
  padding: 10px 20px;
}
.info-qr-title {
  margin-bottom: 6px;
  text-align: center;
}
.info-qr-box {
  margin-right: 20px;
}
.mobile-qr-img {
  cursor: pointer;
}
.info-card-qr {
  width: 200px;
  height: 200px;
}
.card-qr-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.card-qr-img {
  width: 100%;
  height: 100%;
}
.activity-progress {
  padding: 22px 12px;
  border-radius: 8px;
  background-color: #EFF8FF;
  .ant-progress-inner {
    background-color: #ffffff;
  }
}
.card-sub-title {
  margin-top: 20px;
  font-size: 16px;
  color: #333333;
}
.activity-progress-area {
  padding: 20px 20px 6px;
}
.activity-group-list {
  margin: 4px -14px 0;
  font-size: 0;
}
.activity-group-item {
  display: inline-block;
  padding: 10px 14px;
  width: 33.33333333%;
  font-size: 14px;
  line-height: 20px;
}
.activity-group-progress {
  padding: 12px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 4px 0 rgba(90, 63, 0, 0.11);
  .group-status-2 {
    color: #FF4800;
  }
}
.activity-group-name {
  margin-right: 12px;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.group-complete-icon {
  font-size: 20px;
  color: #07C160;
}
.activity-group-more {
  margin: 10px 0 2px;
  text-align: center;
  color: #036DB8;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  cursor: pointer;
}
.info-card-data {
  display: flex;
  align-items: center;
  height: 57px;
  border-radius: 8px;
  background: #EFF8FF;
}
.card-data-item {
  flex: 1;
  height: 32px;
  text-align: center;
  font-size: 14px;
  color: #666666;
  &:not(:first-of-type) {
    border-left: 1px solid #E8E8E8;
  }
}
.card-data-num {
  margin-left: 12px;
  color: #333333;
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
}
.info-chart-item {
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 4px 0 rgba(90, 63, 0, 0.11);
}
.info-chart-num {
  margin-right: 8px;
  padding: 2px 5px;
  border-radius: 6px;
  border: 1px solid #036DB8;
  background: #ffffff;
  font-size: 14px;
  color: #333333;
  line-height: 20px;
}
.info-statistics {
  margin-top: 16px;
}
.type-chart-box {
  margin-top: 16px;
  position: relative;
}
.type-chart-legend {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.chart-legend-item {
  position: relative;
  padding-left: 12px;
  width: 82px;
  line-height: 1;
  &::before {
    content: "";
    display: block;
    position: absolute;
    top: 3px;
    left: 0;
    width: 8px;
    height: 8px;
    border-radius: 100%;
    background-color: #FF8C00;
  }
  &:last-of-type {
    margin-top: 12px;
    &::before {
      background-color: #F5F5F5;
    }
  }
}
.chart-legend-title {
  color: #999999;
  font-size: 14px;
}
.chart-legend-value {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
.type-chart-area {
  position: relative;
  height: 240px;
}
</style>
